/* Phiten India — Mexico-style storefront interactions: slideshow, product carousels,
   mobile menu, category search. No dependencies. */
(function () {
  'use strict';

  function scrollByPage(track, dir) {
    track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
  }

  /* Product carousels */
  document.querySelectorAll('[data-phx-row]').forEach(function (row) {
    var track = row.querySelector('[data-phx-track]');
    var prev = row.querySelector('[data-phx-prev]');
    var next = row.querySelector('[data-phx-next]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var noScroll = max <= 0;
      if (prev) prev.hidden = noScroll;
      if (next) next.hidden = noScroll;
    }
    if (prev) prev.addEventListener('click', function () { scrollByPage(track, -1); });
    if (next) next.addEventListener('click', function () { scrollByPage(track, 1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Slideshow */
  document.querySelectorAll('[data-phx-slides]').forEach(function (root) {
    var track = root.querySelector('[data-phx-track]');
    var slides = track ? track.children : [];
    var dots = root.querySelectorAll('[data-phx-dots] button');
    if (!track || slides.length < 2) return;
    var current = 0, timer = null;
    var seconds = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: current * track.clientWidth, behavior: 'smooth' });
    }
    function mark() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      current = i;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function start() { if (seconds > 0 && !reduce) { stop(); timer = setInterval(function () { go(current + 1); }, seconds * 1000); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    var p = root.querySelector('[data-phx-prev]'), nx = root.querySelector('[data-phx-next]');
    if (p) p.addEventListener('click', function () { go(current - 1); start(); });
    if (nx) nx.addEventListener('click', function () { go(current + 1); start(); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    start();
  });

  /* Mobile menu */
  var mnav = document.querySelector('[data-phx-mnav]');
  function setMenu(open) {
    if (!mnav) return;
    if (open) { mnav.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
    else { mnav.removeAttribute('open'); document.body.style.overflow = ''; }
  }
  document.querySelectorAll('[data-phx-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
  document.querySelectorAll('[data-phx-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* Category search: a category with no search words goes straight to that collection */
  document.querySelectorAll('[data-phx-search]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var cat = form.querySelector('[data-phx-cat]');
      var q = form.querySelector('input[name="q"]');
      if (cat && cat.value && q && !q.value.trim()) { e.preventDefault(); window.location.href = cat.value; }
    });
  });
})();
